<template>
  <div>
    <el-collapse v-model="activeNames" @change="changeList" accordion>
      <el-collapse-item v-for="item in server" :key="item.key" :name="item.id">
        <template slot="title" style="font-size: 24px">
          <i style="margin-right: 6px" class="el-icon-s-unfold"></i
          >{{ item.name }}
        </template>
        <!--
          <el-button
            v-if="activeNames == helpId"
            icon="el-icon-circle-plus-outline"
            type="primary"
            style="margin-left:20px;"
            @click="addDoctor"
          >新增专家</el-button>
        -->
        <el-button
          icon="el-icon-circle-plus-outline"
          type="primary"
          style="margin-left: 20px"
          @click="addProgram"
          >新增项目</el-button
        >
        <el-row v-loading="loading" element-loading-text="加载中">
          <el-col>
            <el-row :gutter="40">
              <el-col
                :span="4"
                v-for="item in tableList"
                :key="item.id"
                style="margin-top: 20px; height: 260px"
              >
                <img
                  v-if="!item.imgsCode"
                  style="width: 100%; height: 100px"
                  src="@/assets/common/program.png"
                  alt
                />
                <img
                  v-else
                  style="width: 100%; height: 100px"
                  :src="item.imgsCode"
                  alt
                />
                <div
                  style="
                    font-size: 20px;
                    font-weight: bold;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  "
                >
                  {{ item.merchandiseName }}
                </div>
                <div style="color: red; font-size: 18px">
                  ￥{{ item.unitPrice }}
                </div>
                <div>
                  <!-- <span v-if="item.isPutaway == 0">上架</span>
                  <span v-else>下架</span> -->
                  <el-switch
                    v-model="item.isPutaway"
                    active-color="#13ce66"
                    active-text="上架"
                    inactive-text="下架"
                    @change="changeOnOff(item)"
                  >
                  </el-switch>
                </div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.remark"
                  placement="top-start"
                >
                  <div class="world">{{ item.remark }}</div>
                </el-tooltip>
                <div style="display: flex; margin-top: 6px">
                  <el-button
                    size="mini"
                    icon="el-icon-edit"
                    type="warning"
                    @click="fix(item)"
                    >修改</el-button
                  >
                  <el-button
                    size="mini"
                    icon="el-icon-delete"
                    type="danger"
                    @click="delet(item)"
                    >删除</el-button
                  >
                </div>
              </el-col>
            </el-row>

            <!-- 专家 -->
            <el-row :gutter="60" v-if="activeNames == helpId">
              <el-col
                :span="4"
                v-for="item in doctorList"
                :key="item.id"
                style="margin-top: 20px; height: 260px"
              >
                <img
                  v-if="!item.imgsCode"
                  style="width: 100%; height: 100px"
                  src="@/assets/common/program.png"
                  alt
                />
                <img
                  v-else
                  style="width: 100%; height: 100px"
                  :src="item.imgsCode"
                  alt
                />
                <div>姓名：{{ item.specialistName }}</div>
                <div>性别：{{ item.gender == 0 ? "男" : "女" }}</div>
                <div>年龄：{{ item.age }}</div>
                <div>医院：{{ item.hospital }}</div>
                <div>擅长：{{ item.speciality }}</div>
                <div>科室：{{ item.administrative }}</div>
                <div style="display: flex; margin-top: 6px">
                  <el-button
                    size="mini"
                    icon="el-icon-edit"
                    type="warning"
                    @click="fixDoctor(item)"
                    >修改</el-button
                  >
                  <el-button
                    size="mini"
                    icon="el-icon-delete"
                    type="danger"
                    @click="deletDoctor(item)"
                    >删除</el-button
                  >
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-collapse-item>
    </el-collapse>

    <!-- 商品弹窗 -->
    <el-dialog
      :title="isAdd ? '新增' : '修改'"
      width="32%"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="closeDialogReset"
    >
      <el-form
        :model="addForm"
        label-width="140px"
        :rules="dataFormRules"
        ref="dataForm"
        label-position="right"
      >
        <el-row type="flex" justify="center">
          <el-col>
            <el-row>
              <el-col :span="20">
                <el-form-item label="项目名称:" prop="merchandiseName">
                  <el-input
                    v-model.trim="addForm.merchandiseName"
                    clearable
                    placeholder="请输入项目名称"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="项目费用:" prop="unitPrice">
                  <el-input-number
                    v-model.trim="addForm.unitPrice"
                    style="width: 220px"
                    controls-position="right"
                    :min="0"
                    :max="9999"
                    :precision="2"
                    auto-complete="off"
                    placeholder="请输入项目费用"
                  >
                  </el-input-number>
                  <div
                    class="unit"
                    :style="
                      !addForm.unitPrice ? 'display:none;' : 'display:block;'
                    "
                  >
                    元
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="服务提成:" prop="serviceFee">
                  <el-input-number
                    v-model.trim="addForm.serviceFee"
                    style="width: 220px"
                    controls-position="right"
                    :min="0"
                    :max="100"
                    :precision="0"
                    @input.native="onInput0_100"
                    onKeypress="return (/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                    placeholder="请输入服务提成"
                  >
                  </el-input-number>
                  <div
                    class="unit"
                    :style="
                      !addForm.serviceFee ? 'display:none;' : 'display:block;'
                    "
                  >
                    %
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="是否有国家补贴:" prop="isSubsidy">
                  <el-radio-group v-model="addForm.isSubsidy">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="20">
                <el-form-item label="服务范围:" prop="communityIds">
                  <el-checkbox-group
                    v-model="addForm.communityIds"
                  >
                    <el-checkbox
                      v-for="item in communityList"
                      :label="item.id"
                      :key="item.id"
                      >{{ item.name }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-row>
              <el-col :span="20">
                <el-form-item label="上传图片:" prop="imgsCode">
                  <el-upload
                    class="avatar-uploader"
                    action="string"
                    accept="image/png, image/jpeg"
                    :show-file-list="false"
                    list-type="picture-card"
                    :before-upload="beforeUpload"
                    :http-request="upload"
                  >
                    <i
                      v-if="addForm.imgsCode"
                      class="el-icon-close closeIcon"
                      style="color: #000"
                      @click="closeImg"
                    ></i>
                    <img
                      style="width: 100%; height: 100%"
                      v-if="addForm.imgsCode"
                      :src="addForm.imgsCode"
                      class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <!--
              <el-row>
                <el-col :span="20">
                  <el-form-item label="项目介绍:" prop="remark">
                    <el-input type="textarea" :rows="4" v-model.trim="addForm.remark"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            -->
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click.native="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitForm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 专家弹窗 -->
    <el-dialog
      :title="isAddDoctor ? '新增专家' : '修改专家'"
      width="32%"
      :visible.sync="doctorDialogVisible"
      :close-on-click-modal="false"
      @close="closeDialogDoctor"
    >
      <el-form
        :model="doctorForm"
        label-width="120px"
        :rules="doctorFormRules"
        ref="doctorForm"
        label-position="right"
      >
        <el-row type="flex" justify="center">
          <el-col>
            <el-row>
              <el-col :span="20">
                <el-form-item label="姓名:" prop="specialistName">
                  <el-input v-model.trim="doctorForm.specialistName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="性别:" prop="gender">
                  <el-radio-group v-model="doctorForm.gender">
                    <el-radio :label="0">男</el-radio>
                    <el-radio :label="1">女</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="上传图片:">
                  <el-upload
                    class="avatar-uploader"
                    action="string"
                    accept="image/png, image/jpeg"
                    :show-file-list="false"
                    list-type="picture-card"
                    :before-upload="beforeUpload"
                    :http-request="upload"
                  >
                    <img
                      style="width: 100%; height: 100%"
                      v-if="doctorForm.imgsCode"
                      :src="doctorForm.imgsCode"
                      class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="年龄:" prop="age">
                  <el-input v-model.trim="doctorForm.age"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="医院:" prop="hospital">
                  <el-input v-model.trim="doctorForm.hospital"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="擅长:" prop="speciality">
                  <el-input v-model.trim="doctorForm.speciality"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="科室:" prop="administrative">
                  <el-input v-model.trim="doctorForm.administrative"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click.native="doctorDialogVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitDoctorForm"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isAdd: true,
      activeNames: "",
      server: [],
      tableList: [],
      dialogVisible: false,
      doctorDialogVisible: false, //专家
      addForm: {
        merchandiseName: "",
        imgsCode: "",
        remark: "",
        communityIds: [],
        secondLevelId: "",
      },
      businessId: "", //商家id
      communityList: [], //服务范围列表
      dataFormRules: {
        merchandiseName: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 10, message: "长度在1到10个字符", trigger: "blur" },
        ],
        unitPrice: [{ required: true, message: "不能为空", trigger: "blur" }],
        serviceFee: [{ required: true, message: "不能为空", trigger: "blur" }],
        remark: [
          { min: 0, max: 300, message: "长度在0到300个字符", trigger: "blur" },
        ],
        communityIds: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
        isSubsidy: [{ required: true, message: "不能为空", trigger: "blur" }],
      },
      doctorForm: {
        specialistName: "",
        gender: "",
        age: "",
        hospital: "",
        administrative: "",
        speciality: "",
        imgsCode: "",
      },
      doctorFormRules: {
        specialistName: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 10, message: "长度在1到10个字符", trigger: "blur" },
        ],
        gender: [{ required: true, message: "不能为空", trigger: "change" }],
        age: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            pattern: /^([0]|[1-9][0-9]*)$/,
            message: "请输入正整数",
            trigger: "blur",
          },
          { min: 1, max: 3, message: "长度在1到3个字符" },
        ],
        hospital: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 15, message: "长度在1到15个字符", trigger: "blur" },
        ],
        administrative: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 15, message: "长度在1到15个字符", trigger: "blur" },
        ],
        speciality: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 15, message: "长度在1到15个字符", trigger: "blur" },
        ],
      },
      id: "",
      doctorList: [], //专家数据
      isAddDoctor: true,
      doctorId: "", //专家id
      helpId: "",
      loading: true,
      typeList: [],
    };
  },
  methods: {
    onInput0_100(e) {
      this.$message.closeAll();
      // 验证是否是纯数字
      let isNumber = /^\d*$/.test(e.target.value);
      // 过滤非数字
      e.target.value = e.target.value.replace(/\D/g, "");
      if (!isNumber || e.target.value < 0 || e.target.value > 100) {
        this.$message.warning("只能输入[0,100]区间的整数");
      }
      e.target.value =
        (e.target.value >= 0 &&
          e.target.value <= 100 &&
          e.target.value.match(/^\d*/g)[0]) ||
        null;
    },
    //获取服务列表
    getServer() {
      this.server = [];
      this.$postForm("uac/merchant/selectLevelId", {
        id: this.businessId,
      }).then((res) => {
        res.result.forEach((item) => {
          this.$postJson("omc/merchandis/selectServiceSecondLevel", {
            secondLevelIds: [item.secondLevelId],
          }).then((res) => {
            this.server.push({
              id: res.result[0].id,
              firstLevelId: res.result[0].firstLevelId,
              name: res.result[0].secondLevelName,
            });
            console.log(this.server);
          });
        });
      });
    },

    //上架下架
    changeOnOff(item) {
      console.log(item);
      //上架
      if (item.isPutaway) {
        this.$postJson("omc/merchandis/on", { merchandiseIds: [Number(item.id)] }).then((res) => {
          if (res.code == 200) {
            this.$message({ message: "上架成功", type: "success" });
            this.getTableList();
          } else {
            this.$message({ message: res.message, type: "error" });
            // 避免switch开关状态改变
            item.isPutaway = !item.isPutaway
          }
        });
      } else {
        //下架
        this.$postJson("omc/merchandis/off", { merchandiseIds: [Number(item.id)] }).then((res) => {
          if (res.code == 200) {
            this.$message({ message: "下架成功", type: "success" });
            this.getTableList();
          } else {
            this.$message({ message: res.message, type: "error" });
            // 避免switch开关状态改变
            item.isPutaway = !item.isPutaway
          }
        });
      }
    },

    //添加项目
    addProgram() {
      this.isAdd = true;
      this.dialogVisible = true;
    },

    //数据上传
    submitForm() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            let param = this.addForm;
            param.secondLevellId = this.activeNames;
            param.unit = 0;
            param.merchantId = this.businessId;

            this.$postJson("omc/merchandis/add", param).then(
              (res) => {
                if (res.code == 200) {
                  this.dialogVisible = false;
                  this.getTableList();
                  this.$message({ message: res.message, type: "success" });
                } else {
                  this.$message({ message: res.message, type: "error" });
                }
              }
            );
          } else {
            let param = this.addForm;
            param.secondLevellId = this.activeNames;
            param.merchantId = this.businessId;
            param.unit = 0;
            param.id = this.id;
            this.$postJson("omc/merchandis/update", param).then((res) => {
              if (res.code == 200) {
                this.dialogVisible = false;
                this.getTableList();
                this.$message({ message: res.message, type: "success" });
              } else {
                this.$message({ message: res.message, type: "error" });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // communityFormatter(row) {
    //   if (row.communityIds) {
    //     let list = [];
    //     let communitList = row.communityIds;
    //     this.communityList.forEach(item => {
    //       communitList.forEach(e => {
    //         if (item.id == e) {
    //           list.push(item.name);
    //         }
    //       });
    //     });
    //     return list.join(",");
    //   }
    // },
    //获取服务范围
    getCommunityList() {
      let params = {
        pageNum: 1,
        pageSize: 999,
      };
      this.$postJson("omc/community/queryListWithPage", params).then((res) => {
        var communityList = [];
        if (res.code == 200) {
          this.communityList = res.result.list;
        } else {
          this.communityList = [];
        }
        console.log(this.communityList, "321321");
      });
    },

    //上传图片
    upload(param) {
      var fileObj = param.file;
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        console.log(form);
        this.$postFormData("opc/file/uploadFile", form).then((res) => {
          if (res.code == 200) {
            this.$postForm("opc/file/queryAttachmentById/" + res.result).then(
              (res) => {
                if (this.activeNames == this.helpId) {
                  this.doctorForm.imgsCode =
                    "http://51cs8.com/" + res.result.path + res.result.name;
                } else {
                  this.addForm.imgsCode =
                    "http://51cs8.com/" + res.result.path + res.result.name;
                }
              }
            );
            this.$message({ message: res.message, type: "success" });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      }
    },

    /* 
      图片验证
    */
    beforeUpload(file) {
      console.log(file);
      let isPNG = false;
      file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isPNG) {
        this.$message.error("上传图片格式不能是 gif 格式");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB");
      }
      return isPNG && isLt2M;
    },

    // 删除图片
    closeImg(e) {
      e.stopPropagation();
      this.addForm.imgsCode = undefined;
    },

    //点击折叠面板
    changeList(row) {
      console.log(row, "1111");
      this.getDoctor();
      this.getTableList();
    },

    //查询列表
    getTableList() {
      let param = {
        secondLevellId: this.activeNames * 1,
        merchantId: this.businessId * 1,
        examineStatus: 0,
      };
      this.$postJson("omc/merchandis/selectmer", param).then(res => {
      // this.$postJson("omc/merchandis/selectByBackstage", param).then((res) => {
        if (res.code == 200) {
          res.result.list.forEach(item => {
            item.isPutaway = item.isPutaway == 1 ? false : true
          })
          this.tableList = res.result.list;
          console.log(this.tableList, "this.tableList");
        } else {
          this.tableList = [];
        }
      });
    },
    //查询商家id
    getBusiness() {
      this.$postForm("uac/merchant/haveId").then((res) => {
        this.businessId = res.result;
        if (this.businessId == null) {
          // this.$message({
          //   type: "error",
          //   message: "该账号已经被删除,请更换账号登录!",
          // });
          // sessionStorage.removeItem("user");
          this.getServer();
        } else {
          this.getServer();
        }
      });
    },

    //关闭弹窗
    closeDialogReset() {
      this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
      this.addForm = {
        merchandiseName: "",
        imgsCode: "",
        remark: "",
        communityIds: [],
        secondLevelId: "",
      };
    },

    //修改
    fix(row) {
      console.log(row,"////");
      this.isAdd = false;
      this.dialogVisible = true;
      this.addForm = JSON.parse(JSON.stringify(row));
      this.addForm.unitPrice = String(row.unitPrice);
      // 0 , 1 
      this.addForm.isSubsidy = row.isSubsidy ? 1 : 0
      this.id = row.id;
    },

    //删除
    delet(row) {
      this.$confirm("是否删除此条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.$postForm("omc/merchandis/delete", { id: row.id }).then((res) => {
          if (res.code == 200) {
            this.$message({ type: "success", message: "删除成功!" });
            this.getTableList();
          } else {
            this.$message({ type: "error", message: res.message });
          }
        });
      });
    },

    //增加专家
    addDoctor() {
      this.doctorDialogVisible = true;
      this.isAddDoctor = true;
    },

    //提交专家数据
    submitDoctorForm() {
      this.$refs.doctorForm.validate((valid) => {
        if (valid) {
          if (this.isAddDoctor) {
            let param = this.doctorForm;
            param.merchantId = this.businessId;
            this.$postJson("omc/specialist/add", param).then((res) => {
              if (res.code == 200) {
                this.$message({ type: "success", message: res.message });
                this.doctorDialogVisible = false;
                this.getDoctor();
              } else {
                this.$message({ type: "error", message: res.message });
              }
            });
          } else {
            let param = this.doctorForm;
            param.id = this.doctorId;
            this.$postJson("omc/specialist/update", param).then((res) => {
              if (res.code == 200) {
                this.$message({ type: "success", message: res.message });
                this.doctorDialogVisible = false;
                this.getDoctor();
              } else {
                this.$message({ type: "error", message: res.message });
              }
            });
          }
        } else {
          return false;
        }
      });
    },

    //查询专家
    getDoctor() {
      this.loading = true;
      this.$postJson("omc/specialist/select", {
        merchantId: this.businessId,
      }).then((res) => {
        this.doctorList = res.result.list;
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      });
    },

    //修改专家
    fixDoctor(row) {
      this.isAddDoctor = false;
      this.doctorDialogVisible = true;
      this.doctorForm = JSON.parse(JSON.stringify(row));
      this.doctorForm.age = String(this.doctorForm.age);
      this.doctorId = row.id;
    },

    //删除专家
    deletDoctor(row) {
      this.$confirm("是否删除该专家?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.$postForm("omc/specialist/delete", { id: row.id }).then((res) => {
          if (res.code == 200) {
            this.$message({ type: "success", message: "删除成功!" });
            this.getDoctor();
          } else {
            this.$message({ type: "error", message: res.message });
          }
        });
      });
    },

    //关闭专家弹窗
    closeDialogDoctor() {
      this.$refs.doctorForm.resetFields(); //移除校验结果并重置字段值
      this.doctorForm = {};
    },
  },
  mounted() {
    this.getBusiness();
    // this.getCommunityList();
  },
};
</script>
<style lang="scss" scoped>
::deep .el-collapse-item__header {
  font-size: 18px;
}
.remark {
  width: 100%;
}
.world {
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.unit {
  position: absolute;
  left: 150px;
  top: 50%;
  transform: translateY(-50%);
}
.closeIcon {
  z-index: 999;
  position: absolute;
  top: 0;
  left: 130px;
  font-size: 16px;
}
</style>
